
import { useRoute, useRouter,onBeforeRouteLeave} from 'vue-router'
import { toRefs, defineComponent, reactive, ref, getCurrentInstance, watch, computed, nextTick, onMounted,onActivated} from 'vue'
import { useStore } from '@/store/index'
import { AppActionTypes } from '@/store/modules/app/action-types'
import { UserMutationTypes } from '@/store/modules/user/mutation-types'
import { VueDraggableNext } from 'vue-draggable-next'
import { BrandCat } from '@/enums/brand'
import { CheckStatus, ProductO } from '@/enums/product'
import { InvoiceType } from '@/enums/others'
import { beforeUpload, upload, fileUpload } from '@/utils/upload'
import { getStrLength, clearBr } from '@/utils/index'
import { isValidURL, isSensitive,isArray } from '@/utils/validator'
import { Plus, Delete, VideoCameraFilled, Picture, Loading } from '@element-plus/icons-vue'
import { updateSpecStatusAPi, checkIngredientsImage } from '@/apis/product'
import { offTypes,filterTypes } from './enum'
import { updateAttachmentStatusApi } from '@/apis/brand'
import { getSecondBrandListNoPageApi } from '@/apis/merchant-admin'
import AutoDetailsImg  from './AutoDetailsImg.vue'
interface ImgItemInt {
    uid: number,
    id: number,
    url: string,
    file_name: string 
}

export default defineComponent({
name: 'ProductEdit',
components: {
    Plus,
    Delete,
    draggable: VueDraggableNext,
    VideoCameraFilled,
    AutoDetailsImg,
    Picture,
    Loading
},

setup () {
    const { proxy } = getCurrentInstance() as any
    const router = useRouter()
    const route = useRoute()
    const store = useStore()
    const activeName = ref('first')
    // store.dispatch(AppActionTypes.ACTION_SET_KEEPALIVE, true)
    const ChargeType = ['type-0', 'type-1','type-2','type-3','type-4','type-5','type-6',]
    const groupIdArr = store.state.user.userInfo.group_id.split(',').map(Number) // 当前用户拥有角色权限ID
    const userType = store.state.user.userInfo.user_type // 当前用户拥有角色权限ID
    const { id, t, o, v } = route.query
    const is_snacks = store.state.user.userInfo.is_snacks || 0 // 商家账户类型 1- 零食+蛋糕品类'   2-纯零食类  3-其他

    const forbiddenUserIds = ref(new Set([6368, 7097, 7098]))
    // 默认比价承诺书
    const default_merchant_promist_letter = 'https://dgss-oss-zs.oss-cn-beijing.aliyuncs.com/shop_vedio/%E4%BB%B7%E6%A0%BC%E6%89%BF%E8%AF%BA%E4%B9%A620250730.docx';
    const state = reactive<any>({
        t:  t,  // 页面展示状态：view-查看，edit-编辑，check-审核
        o:  o,  // 页面来源：1、商品列表-已上线，2、商品列表-添加，3、审核列表，4、商品列表-待上线
        v:  v,  // 是否需要校验：当用户在列表页进行上架操作时，如果检查到信息不完善，进入此页面获取商品信息后需要触发校验
        source:route.query.source || '', // 来源，source：1-运营，2-商户
        brandLimit: 0, // 当前品牌还可上架的商品数量
        pageLoaded:  false, // 页面是否加载完成
        isAddDetailImg:0,
        user_id:   store.state.user.userInfo.id,
        props:{
            expandTrigger: 'hover',
            value:'id',
            label:'name',
            disabled: (node) => {
                return  node.disabled === true; // 如果审核页面是药食同源则返回 true
            }
        },
        propCitys:{
            expandTrigger: 'hover',
            value:'id',
            label:'lable',
            multiple: true,
            children:'options'
        },
        ClassifyProps:{
            expandTrigger: 'hover',
            value:'id',
            label:'lable',
            multiple: true,
            emitPath: false,
            children:'labels',
            disabled: (node) => {
                return node.level === 1 || node.disabled === true; // 如果是一级选项或者是药食同源则返回 true
            }
        },
        ClassifyOptions:[],
        GroupOptions:[],
        radioTypes: [0, 1, 2, 3, 4, 5], // 可选类型
        optionCitys:[],
        LogisticsList:[],
        isAuto:0,
        options:[],
        selectedFirstLevel:[],
        shop_discount:'',   //品牌折扣
        cat_id3_discount: 0,  //3级分类折扣
        secondary_brand_discount: 0,  //二级品牌折扣
        minDiscount:0, //最低折扣
        showNotice: false,  //京东、顺丰注意事项显示
        is_kd:'',           //是否为快递
        is_tc:'',           //快递弹窗输入框品牌过滤
        formData: {
            /* 必填项 */
            admin_name: store.state.user.userInfo.username, // 操作人
            save_id:            id,     // 商品ID
            is_on_line:         0,      // 操作来源
            check_status:       0,      // 状态
            status:             '',      // 运营上下架商品
            brand_id:           null,   // 品牌ID
            brand_cat_id:       null,   // 品牌品类ID
            title:              '',     // 商品名称
            title_new:          '',     // 变更后的商品名称
            description:        '',     // 商品描述
            description_new:    '',     // 变更后的商品描述
            is_gross:           0,      // 是否为蛋叔甄选商品，默认否
            image_id:           '',     // 列表图ID：在商品图中选中一个
            image_path:         '',     // 列表图Ulr
            ingredient_img:     [],     // 配料表图列表
            poster:             '',     // 商品视频封面图
            video:              '',     // 商品视频
            product_images_list:[],     // 商品图列表
            content_images_list:[],     // 商品详情图列表
            is_compare:         1,      // 是否加入比价
            compare_url:        '',     // 比价链接
            compare_msg:        '',     // 不加入比价原因
            cat_id:             '',     // 当前商品品类
            cat_id2:             '',     // 当前商品分类2级
            cat_id3:             '',     // 当前商品分类3级
            specs_list:         [],     // 规格列表
            kf_compare_url:     '',     //客服比价链接
            kf_compare_price:   '',     //客服比价价格
            is_choiceness:       0,     //是否为精选商品
            extra_data: {   // 蛋糕额外配置项
                material:       '',     // 原料
                taste:          '',     // 口感
                sweetness:      '',     // 甜度
                storage:        '',     // 储存条件
                introduce:      '',     // 包装
                shipping_addr:  '',     // 发货地
                expiry_days:    null,   // 保质期
            },
            reserve_type:'',            //储存方式
            delivery_addr:      '',     //发货地址
            wuliu_cats:         '',    // 物流的参数
            /* 非必填项 */
            is_pre_sale:        0,      // 是否为预售商品：0-否，1-是
            pre_sale_date:      '',     // 预售日期
            yushou_end_date:    '',     // 预售结束日期  
            invoice_type:       '',     // 发票类型
            tax_Point:          null,   // 税点
            charges_list:       [],     // 收费附件
            label_name:         [],     // 商品标签
            classify_label:         [],     // 分类标签
            labels:'',     // 新标签体系
            group_label:         [],     // 分组标签
            special_tag:        '',     // 特殊节日标签
            tag_list:           {},     // 某品类下的标签组合：蛋糕包含，蛋糕分类、蛋糕口味等；零食包含,零食分类、零食价格等；鲜花包含，鲜花分类等
            secondary_id:        null,  // 已关联平台二级品牌ID
            second_brand_name:  '',     // 二级品牌名称
            is_greeting:        0,      // 是否支持配置祝福语
            greeting_num:       0,      // 祝福语字符长度限制
            is_voluntarily:     0,      // 是否定时上架
            voluntarily_time:   null || '',   // 定时上架时间
            save:               [],     // 审核时已修改字段标识
            pasteImg: '', // 剪切板图片传值
            pasteimg_path: [], // 剪切板图片
            deleteImg:'', // 旧数据中删除的图片
            merchant_compare_price:'',
            merchant_compare_num:'',
            merchant_checked_promise:0,
            merchant_compare_image:[],
            compare_image:'',  
            merchant_promise_letter:'',
            is_yy_check:0,
            spu:'',
        },
        oldDeleteArray:[], // 每次删除的旧图片数组
        deleteArray:[], // 每次删除的图片数组
        oldMerchantDeleteArray:[],
        merchantDeleteArray:[],
        oFormData:              {},     // 商品详情接口返回原始数据，在提交时需要原封不动的进行回传，以标识已更改字段
        hour:                   '',     // 当前选中时间
        brandList:              [],     // 品牌列表
        tagList:                [],     // 商品标签列表
        specDialog:             false,  // 规格编辑弹框
        chargeDialog:           false,  // 收费附件编辑弹框
        rejectDialog:           false,  // 驳回弹框
        check_msg:          '',     // 驳回原因
        currSpecIndex:          -1,     // 当前编辑规格索引值
        srcList:                [],     //规格图片
        soldout_type:           [],     //下架类型
        soldout_reson:          '',     //下架原因
        soldout_time:           '',     //下架时间
        shelf:{
            soldout_type:           '',     //下架类型
            soldout_reson:          '',     //下架原因
        },
        productShelfShow:       false,  //运营下架商品
        specOptions: {      // 添加规格所需参数
            id:                 '',     // 规格ID
            name:               '',     // 规格名称
            spec_img:           '',     //规格图片
            description:        '',     // 规格描述
            tastes:             '',     // 口味或颜色
            market_price:       '',     // 市场价
            price:              '',     // 售价
            stock:              '',     // 库存
            clearing_price:     '',     // 结算价
            gift:               '',     // 配套餐具
            sku:                '',     // SKU
            is_import:           0,     // 是否为进口
            product_code:       '',     // 69码
            unit:               '',     //商品单位
            shop_discount:      '',     // 规格折扣
            deleted:            0,      // 是否隐藏  
            is_new:             '',     // 是否为最新上传
            is_activity:        0,      // 是否为活动规格（活动规格价格、折扣不允许修改）
            isUnlimited:    false, // 是否无限量库存
            code_spec_name: '',
            code_name:  '',
            code_firm_name: '',
            code_brand_name: '',
            code_img: '',
            sc_num: 0,
            product_code_add:false,
        },
        video_name:'',
        currChargeIndex:        -1,     // 当前编辑收费附件索引值
        chargeOptions: {    // 添加收费附件所需参数
            id:                 '',     // 附件ID
            name:               '',     // 附件名称
            unity:              '份',     // 单位
            price:              '',     // 单价
            type:               '',     // 附件类型
            limit:              '',     // 限购数
            sku:                '',     // SKU
            status:             1,      // 状态：0-下架，1上架
            is_candle:          '',     //收费附件类型   
        },
        imgPreviewList:         [],     // 商品图预览列表
        ingredientPreviewList:  [],     // 配料表图预览列表
        contentImgPreviewList:  [],     // 详情图预览列表
        specimgPreviewList:     [],     // 规格图预览列表
        pasteImgPreviewList:    [],     // 粘贴图片预览列表
        MerchantCompareImgPreviewList:[],
        imageUrl:'',
        is_check:0,
        product_id:'',
        productArr:[],                // 搜索条件商品数组
        second_brand_name_type:false, //69码品牌和二级品牌是否一致
        formatPrice: () => {
            let newValue = state.chargeOptions.price.replace(/[^\d.]/g, ''); // 只保留数字和小数点
            let parts = newValue.split('.');
            
            // 限制小数点前最多两位数
            if (parts[0].length > 2) {
            parts[0] = parts[0].slice(0, 2);
            }

            // 限制小数点后最多两位数
            if (parts.length > 1) {
                parts[1] = parts[1].slice(0, 2); // 保留两位小数
            }

            state.chargeOptions.price = parts.join('.');
        },
        // 获取分类标签
        getClassifyList: (cat_id) =>{
            proxy.$http.get('/label/labelClassifyList', { type: 1,cat_id }).then((res:any) => {
                const { code, data, msg } = res
                if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
                if((state.source == '2') || (state.t === 'check' && state.o == 3)){
                    data.forEach(dataItem => {
                        if(dataItem.id === 18){
                            dataItem.disabled = true;
                        }
                        dataItem.labels?.forEach(label => {
                            if (label.id === 321) {  
                            label.disabled = true; // 添加 disabled 属性
                            }
                        });
                    });
                }
                state.ClassifyOptions = data      
            })
        },
        // 获取分类标签
        getGroupList: (cat_id) =>{
            // proxy.$http.get('/label/labelGroupingList', { type: 2 }).then((res:any) => {
            //     const { code, data, msg } = res
            //     if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
            //     state.GroupOptions = data                  
            // })
            // 明确返回 Promise
            return new Promise((resolve, reject) => {
                proxy.$http.get('/label/labelGroupingList', { type: 2,cat_id }).then((res) => {
                    const { code, data, msg } = res;
                    if (code != 200) {
                        proxy.$message({ type: 'error', message: msg });
                        reject(msg);  // 如果请求失败，调用 reject
                    } else {
                        if((state.source == '2') || (state.t === 'check' && state.o == 3)){
                            data.forEach(dataItem => {
                                if(dataItem.id === 18){
                                    dataItem.disabled = true;
                                }
                                dataItem.labels?.forEach(label => {
                                    if (label.id === 321) {  
                                    label.disabled = true; // 添加 disabled 属性
                                    }
                                });
                            });
                        }
                        state.GroupOptions = data;
                        resolve(data);  // 请求成功，调用 resolve
                    }
                }).catch(error => {
                    proxy.$message({ type: 'error', message: '获取数据失败' });
                    reject(error);  // 捕获错误并调用 reject
                });
            });
        },
        //获取商品类目
        getProductCats: () => {
            proxy.$http.get('/admin/cats/getListData',{pid:state.formData.cat_id,brand_id:state.formData.brand_id}).then(res => {
                const { code, data, msg } = res
                if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
                state.options = data
                const {cat_id3} = state.formData
                let discount = 0;
                const search = (arr) => {
                    arr.forEach(item => {
                        if (item.id === cat_id3) discount = Number(item.limit_discount) || 0;
                        if (!discount && item.children?.length) search(item.children);
                    });
                }
                search(data);
                state.cat_id3_discount = discount
                // 商户端添加页面不展示药食同源分类
                if(state.source == '2' && state.o == 2){
                    const index = state.options.findIndex(item => item.name === '药食同源');
                    if (index !== -1) {
                    state.options.splice(index, 1);
                    }
                }
                // 审核页面禁用药食同源分类
                if(state.t === 'check' && state.o == 3){
                    state.options.forEach(dataItem => {
                        if (dataItem.id === 111) {
                            dataItem.disabled = true; // 添加 disabled 属性
                        }
                    });
                }
                 // 如果是编辑状态且有三级分类
                if (t === 'edit' && state.formData.cat_id3 && state.o !=4 && state.source == '2') {
                    // 遍历选项，根据是否为选中的一级级联项来设置 disabled 属性,即上线过的商品不可再次选择二级分类
                    state.options.forEach(option => {
                    if (option.id == state.formData.cat_id2) {
                        option.disabled = false;
                    } else {
                        option.disabled = true;
                    }
                    });
                }
                
                // 循环判断三级分类可上架商品数量是否已达到上限
                state.options.forEach(cat2 => {
                    cat2.children.forEach(cat3 => {
                        if (cat3.is_disabled) {
                            cat3.name += '（可上架数达到上限）'
                            cat3.disabled = cat3.is_disabled
                        }
                    });
                });
                // 所有商家，不可以选择面包糕点分类,截止到3.31,角色包含56(运营平台组)的还是展示面包糕点
                if((!groupIdArr.includes(56) && state.source == '2' && new Date() < new Date('2026-03-18 23:59:59')))
                state.options.forEach(dataItem => {
                    const index = dataItem.children.findIndex(item => item.name === '面包糕点');
                    if (index !== -1) {
                        dataItem.children[index].disabled = true
                    }
                });
            })
            const { cat_id } = state.formData
            if(cat_id){
                state.getClassifyList(cat_id)
                state.getGroupList(cat_id)
            }     
        },
        // 获取全部城市
        getAllCityList (){
            proxy.$http.get('/cake_api/getCityListByBrandId').then((res:any) => {
                const { code, data, msg } = res
                if (res.code != 200) { return proxy.$message({ type: 'error', message: res.msg }) }
                data.options = res.data
                state.optionCitys = data
                
            })
        },
        removeStr: (str) => {
            const arr = str.split("人食");
            return arr.join("");
        },
        autoImg: ()=>{
            nextTick(() => {
                proxy.$refs.AutoDetailsImg.openDialog()
            })
            state.isAddDetailImg = 0
        },
        loadAndAddImage: ()=>{
            // 从 localStorage 读取字符串并转换回数组
            const imagesJson = localStorage.getItem('uploadedImage');
            const imagesArray = imagesJson ? JSON.parse(imagesJson) : [];
            if (imagesArray.length >0) {
                state.isAuto = 1
                // 直接添加到响应式状态数组中
                state.formData.content_images_list=imagesArray;
                state.contentImgPreviewList = []
                state.formData.content_images_list.map((item:ImgItemInt) => {
                    if (item.id && item.url) {
                        // @ts-ignore
                        state.contentImgPreviewList.push(item.url)
                    }
                })
            }
        },
        // 格式化数字
        formatPrecision: (val: any) => {
            var result = val.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
            if (result.split('.').length > 1) {
                result = result.split('.')[0] + '.' + result.split('.')[1].slice(0, 2);
            }
            return result;
        },
        checkGroupLabelMatch: () => {
            // 确保 GroupOptions 有值
            if (!state.GroupOptions || state.GroupOptions.length === 0) {
                return;
            }

            const { group_label } = state.formData;
            let hasMatch = false;

            // 遍历 GroupOptions，检查是否有一个匹配的 id
            for (const group of state.GroupOptions) {
                for (const label of group.labels) {
                    if (group_label && group_label.includes(label.id)) {
                        hasMatch = true;
                        break;
                    }
                }
                if (hasMatch) break; // 只要找到一个匹配项，就停止检查
            }

            // 根据匹配结果决定是否清空 group_label
            if (!hasMatch) {
                state.formData.group_label = [];
            }
        },
        // 组合调用方法
        executeWithGroupData: () => {
            state.getGroupList(state.formData.cat_id).then(() => {
                state.checkGroupLabelMatch(); // 数据加载后再调用匹配逻辑
            }).catch((error) => {
                console.error('获取 GroupOptions 数据失败:', error);
            });
        },
        //获取商品信息
        getProductInfo: () => {
            const { save_id } = state.formData
            proxy.$http.post('/cake_api/product_details', { save_id, is_on_line:state.o }).then((res) => {
                const { code, data, msg } = res
                if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
                
                state.oFormData = JSON.parse(JSON.stringify(data)) // 保存原始数据
                state.srcList = ['https://dgss-oss-zs.oss-cn-beijing.aliyuncs.com/specs/specs_20230515144308_501.jpg']
                if(data.extra_data == null){
                    data.extra_data={
                        'material':       '',     // 原料
                        'taste':          '',     // 口感
                        'sweetness':      '',     // 甜度
                        'storage':        '',     // 储存条件
                        'introduce':      '',     // 包装
                        'shipping_addr':  '',     // 发货地
                        'expiry_days':    null,   // 保质期
                    }
                }
                if (data.voluntarily_time) {
                    const timeArr = data.voluntarily_time.split(' ')
                    data.voluntarily_time = timeArr[0]
                    state.hour = timeArr[1]
                }
                data.secondary_id = data.secondary_id || null // 重置二级品牌默认值
                data.invoice_type = data.invoice_type || '' // 重置发票类型默认值
                data.tax_Point = data.tax_Point || null // 重置税点默认值
                if (t!='check' && t!='view') {
                    data.specs_list.map((item:any) => { // 保存原售价和原结算价
                        item.old_price = item.price
                        item.old_clearing_price = item.clearing_price
                        
                    })
                }
                // 当接口返回默认值时将值置空，解决将默认值识别为今天，上传者误认为自己已选择实际并没有选择的问题
                if (data.pre_sale_date === '0000-00-00') {
                    data.pre_sale_date = ''
                }
                if (data.yushou_end_date === '0000-00-00') {
                    data.yushou_end_date = ''
                }
                
                state.formData = data
                // 配料表图
                if (data.ingredient_img) {
                    state.ingredientPreviewList = data.ingredient_img.split(',')
                    data.ingredient_img = data.ingredient_img.split(',')
                } else {
                    data.ingredient_img = []
                }
                //比价图片预览图
                state.pasteImgPreviewList = !data.pasteimg_path ? [] :
                                            Array.isArray(data.pasteimg_path) ?
                                            data.pasteimg_path.map(item => item.pasteImg) :
                                            data.pasteimg_path.split(',').map(item => item.pasteImg)
                // 商家比价截图预览图
                state.MerchantCompareImgPreviewList = !data.merchant_compare_image ? [] :
                                            Array.isArray(data.merchant_compare_image) ?
                                            data.merchant_compare_image.map(item => item.pasteImg) :
                                            data.merchant_compare_image.split(',').map(item => item.pasteImg)
                // 商品图和详情图预览列表数据
                state.contentImgPreviewList = data.content_images_list.map(item => {
                    if (item) {
                        return (item.url?.replace('?x-oss-process=style/s_img_160', ''))?.replace('_s.jpg', '.jpg')
                    }
                })
                const { cat_id } = state.formData
                if(cat_id){
                    state.getClassifyList(cat_id)
                    state.getGroupList(cat_id)
                    state.executeWithGroupData()
                }
                if(data.labels){
                    state.formData.classify_label = data.labels.split(',').map(label => parseInt(label, 10));
                    state.formData.group_label = data.labels.split(',').map(label => parseInt(label, 10));
                }else {
                    state.formData.classify_label = []
                    state.formData.group_label = []
                }
                resetTagList()
                nextTick(() => {
                    if (state.v) proxy.$refs.productForm.validate() // 当用户在列表页进行上架操作时，如果检查到信息不完善，进入此页面获取商品信息后需要触发校验
                    if (state.t === 'view') proxy.$refs['label_name-form-item']?.clearValidate() // 非编辑状态取消 label_name 错误提示
                    state.pageLoaded = true // 此时页面数据渲染完成
                })
            })
        },
        handleChange: (value) => {
            if (value) {
                state.formData.cat_id2 = value[0]
                state.formData.cat_id3 = value[1]
            } else {
                state.formData.cat_id2 = ''
                state.formData.cat_id3 = ''
            }
        },
        /**
         * 商户端：保存、提交
         * type：0-保存，1-提交
        */
        submitForm: async (type:number) => {
            if (type === 0) { // 执行暂存
                state.onStash(type);
                return;
            }

            const { formData, hour, o, oFormData, tagList } = state
            // 检查商品名称、商品介绍是否包含敏感词
            const titleSensitiveResult = await isSensitive(formData.title)
            if (titleSensitiveResult !== true) return proxy.$message({ type: 'error', message: `商品名称中包含敏感词：${titleSensitiveResult}` })
            const descSensitiveResult = await isSensitive(formData.description)
            if (descSensitiveResult !== true) return proxy.$message({ type: 'error', message: `商品介绍中包含敏感词：${descSensitiveResult}` })

            proxy.$refs['productForm'].validate((valid:boolean) => {
                if (valid) {
                    const electricAppliance = [78, 90];
                    if(electricAppliance.includes(formData.cat_id3) && !formData.video) return proxy.$message({ type: 'error', message: '请上传商品视频' })
                    // 检查商品介绍是否超长
                    // if (formData.description.length > 100) return proxy.$message({ type: 'error', message: '商品介绍长度不可超100个字符' })
                    // 检查商品视频上传时是否同时上传了封面图
                    if (formData.video && !formData.poster) return proxy.$message({ type: 'error', message: '请上传商品视频封面图' })
                    // 检查商品图是否大于等3张
                    if (formData.product_images_list.length < 3) return proxy.$message({ type: 'error', message: '商品图不能少于3张' })
                    // 检查是否选择了列表图
                    if (!formData.image_id) { return proxy.$message({ type: 'error', message: '请选择列表图' }) }
                    if ((formData.cat_id == 5 || formData.cat_id3 == 44) && formData.cat_id2 != 76 && formData.ingredient_img.length == 0) {
                        return proxy.$message({ type: 'error', message: '请上传配料表图' })
                    }
                    // 检查是否上传了商品详情图
                    // @ts-ignore
                    if (formData.content_images_list.length === 0) {
                        return proxy.$message({ type: 'error', message: '请上传商品详情图' })
                    } else {
                        for (let i=0,len=formData.content_images_list.length; i<len; i++) {
                            // @ts-ignore
                            if (!formData.content_images_list[i].url) {
                                return proxy.$message({ type: 'error', message: `第 ${i+1} 张图片错误，请删除后重新上传` })
                            }
                        }
                    }
                    if (formData.is_compare == 1 && formData.merchant_compare_num <= 200 && formData.merchant_checked_promise == 0 && (state.source == 2 || state.o == 3 )) { return proxy.$message({ type: 'error', message: '请勾选价格承诺书' }) }
                    if (formData.is_compare == 1 && formData.merchant_compare_image.length < 1 && (state.source == 2 || state.o == 3 )) return proxy.$message({ type: 'error', message: '比价截图不能为空' })
                    let tmpFormData = { ...formData }
                    // 检查标签项是否全部已选
                    // const { tag_list } = tmpFormData
                    // for (let key in tag_list) {
                    //     if (tag_list[`${key}`].length === 0) {
                    //         // @ts-ignore
                    //         let group_name = (tagList.find((item:any) => item.group_id==key))['group_name']
                    //         return proxy.$message({ type: 'error', message: `请选择${group_name}` })
                    //     }
                    // }
                    // 检查是否选择了标签或者标签组
                    if( userType == 1 && formData.classify_label.length === 0 && formData.group_label.length === 0){
                        return proxy.$message({ type: 'error', message: '请选择标签或者标签组' })
                    }
                    tmpFormData.voluntarily_time = tmpFormData.voluntarily_time ? `${tmpFormData.voluntarily_time} ${hour || hourList[0]}` : ''
                    tmpFormData.check_status = type
                    // @ts-ignore
                    tmpFormData.image_path = (tmpFormData.product_images_list.find((item:any) => item.id == tmpFormData.image_id))['url']
                    // @ts-ignore
                    tmpFormData.is_on_line = o
                    // 合并两个数组
                    // @ts-ignore
                    const combinedLabels = [...tmpFormData.classify_label, ...tmpFormData.group_label];

                    // 去重
                    const uniqueLabels = Array.from(new Set(combinedLabels));
                      // 检查标签或者标签组包含药食同源，二级分类是否与其保持一致
                    if(uniqueLabels.includes(321) && tmpFormData.cat_id2 !== 111){
                        return proxy.$message({ type: 'error', message: '非药食同源二级分类，不可打药食同源标签' })
                    }
                    if(uniqueLabels.indexOf(321) === -1 && tmpFormData.cat_id2 === 111){
                        return proxy.$message({ type: 'error', message: '请选择药食同源标签' })
                    }
                    // 转换为逗号分隔的字符串
                    tmpFormData.labels = uniqueLabels.join(',');
                    // @ts-ignore
                    if (tmpFormData.secondary_id === null) { tmpFormData.secondary_id = 0 } // 如果二级品牌为null改为0，数据该字段不允许为null
                   // 
                    function processPasteImg(formData) {
                        const pasteImgPath = formData?.pasteimg_path;
                        if (isArray(pasteImgPath) && pasteImgPath.length > 0) {
                            const pasteImgArray = pasteImgPath.map(item => item?.pasteImg).filter(img => img != null && img !== '');
                            return pasteImgArray.length > 0 ? pasteImgArray.join(',') : '';
                        } 
                        else if (typeof pasteImgPath === 'string') {
                            return pasteImgPath;
                        }
                        return '';
                    }
                    let oImgResult = processPasteImg(oFormData);
                    let newPasteImg = oImgResult;
                    let new_merchant_compare_image;
                    if(formData.is_compare == 1 && formData?.merchant_compare_image && formData?.merchant_compare_image.length > 0) {
                        const compareImage = formData.merchant_compare_image.map(item => item?.pasteImg).filter(img => img != null && img !== '');
                        if(compareImage.length > 0){   
                            compareImage.join(',')      
                        }
                        new_merchant_compare_image = compareImage.join() || ''
                    }else{
                        new_merchant_compare_image = ''
                    }
                    // 根据source字段判断来源页面1运营端、2商户端
                    if(state.source == '1'){
                        if (!state.isValidGross()) { // 检查预售标签是否正常
                            return false
                        }
                        proxy.$http.post('/cake_api/yy_operation_check', {
                            ...tmpFormData,
                            oFormData,
                            pasteimg_path: newPasteImg,
                            merchant_compare_image: new_merchant_compare_image,
                            ingredient_img: state.formData.ingredient_img.join(',')
                        }).then((res:any) => {
                            if(res.code == 200){
                                proxy.$message({ type: 'success', message: '操作成功' })
                                localStorage.removeItem('uploadedImage');
                                router.go(-1)
                            }else{
                                proxy.$message({type:'error',message:res.msg})
                            }
                        })
                    }else{
                        proxy.$http.post('/cake_api/alteration_product', {
                            ...tmpFormData,
                            oFormData,
                            pasteimg_path: newPasteImg,
                            merchant_compare_image: new_merchant_compare_image,
                            ingredient_img: state.formData.ingredient_img.join(',')
                        }).then((res:any) => {
                            if(res.code == 200){
                                proxy.$message({ type: 'success', message: '操作成功' })
                                localStorage.removeItem('uploadedImage');
                                router.go(-1)
                            }else{
                                proxy.$message({type:'error',message:res.msg})
                            }
                        })
                    }
                    
                } else {
                    moveToErr() // 跳转到第一个报错项
                }
            })
        },
        // 暂存提交
        onStash: async (type: number) => {
            const { formData, hour, o, oFormData, tagList } = state
            let tmpFormData = { ...formData }
            
            if (!tmpFormData.brand_id) {
                return proxy.$message({ type: 'error', message: '请选择品牌' })
            }
            tmpFormData.voluntarily_time = tmpFormData.voluntarily_time ? `${tmpFormData.voluntarily_time} ${hour || hourList[0]}` : ''
            tmpFormData.check_status = type
            tmpFormData.image_path = (tmpFormData.product_images_list.find((item:any) => item.id == tmpFormData.image_id))?.url || ''
            tmpFormData.is_on_line = o
            // 合并两个数组
            const combinedLabels = [...tmpFormData.classify_label, ...tmpFormData.group_label];

            // 去重
            const uniqueLabels = Array.from(new Set(combinedLabels));

            // 转换为逗号分隔的字符串
            tmpFormData.labels = uniqueLabels.join(',');
            if (tmpFormData.secondary_id === null) { tmpFormData.secondary_id = 0 } // 如果二级品牌为null改为0，数据该字段不允许为null
            
            proxy.$http.post('/cake_api/thislocalityProduct', {
                ...tmpFormData,
                oFormData,
                ingredient_img: state.formData.ingredient_img.join(',')
            }).then((res:any) => {
                if(res.code == 200){
                    proxy.$message({ type: 'success', message: '暂存成功' })
                    localStorage.removeItem('uploadedImage');
                }else{
                    proxy.$message({type:'error',message:res.msg})
                }
            })
        },
        //打开下架原因弹窗
        openDialog () {
            state.shelf.soldout_type = ''
            state.shelf.soldout_reson = ''
            state.productShelfShow = true
        },
        //取消下架
        onProductShelfShow () {
            state.shelf.soldout_type = ''
            state.shelf.soldout_reson = ''
            state.productShelfShow = false
            nextTick(() => {
                proxy.$refs['shelfProductForm'].clearValidate()
            })
        },
        /**
         * 判断蛋叔甄选逻辑：
         *  如果选择是则商品名称必须以【蛋叔甄选】开头（该判断条件由于需要区分渠道商品和平台商品，暂时屏蔽）
         *  如果选择否不能以【蛋叔甄选】开头
         * */
        isValidGross () {
            let result = true
            const { title, title_new, is_gross } = state.formData
            const regex = /^【预售】【蛋叔甄选】|^【蛋叔甄选】/
            const title_str = title_new ? title_new : title
            const startWithKeyword = title_str.match(regex)

            // if (is_gross === 1 && !startWithKeyword) {
            //     proxy.$message({ type: 'error', message: '标记为蛋叔甄选的商品名称必须以【蛋叔甄选】开头' })
            //     result =  false
            // }
            if (is_gross === 0 && startWithKeyword) {
                proxy.$message({ type: 'error', message: '该商品名称存在疑问，需与蛋叔甄选设置保持一致' })
                result =  false
            }
            return result
        },
        /**
         * 运营审核：1-通过并上架，2-通过并下架，3-驳回
        */
        onCheck: (check_type:number) => {
            const { formData, check_msg, hour,shelf } = state
            const {soldout_type,soldout_reson} = shelf
            const { save_id, is_voluntarily, voluntarily_time,kf_compare_url,kf_compare_price,is_choiceness,labels,classify_label,group_label, title, title_new, is_gross,cat_id,cat_id3,pasteimg_path } = formData
            
            if (check_type !== 3 && !state.isValidGross()) {
                return false
            }
            // 只有零食+蛋糕下的面包糕点审核比价照片、价格和链接驳回非必填，上架或下架必填
            if (check_type !== 3 && (cat_id == 5 || cat_id3 == 44) && (!kf_compare_url || !kf_compare_price || pasteimg_path.length == 0)) {
                proxy.$message({ type: 'error', message: '请输入审核人员比价图片、比价链接和比价价格' })
                return
            }

            // 填写驳回原因
            if (check_type === 3 && !check_msg) {
                return proxy.$message({ type: 'error', message: '请输入驳回原因' })
            }
            //运营下架填写原因
            if (check_type === 2 && !soldout_type) {
                proxy.$message({ type: 'error', message: '请选择下架类型' })
                return
            }
            
            if(state.formData.pasteimg_path.length > 0) {
                // 找出状态为1的项，并将它们的pasteImg属性提取出来
                const pasteImgArray = state.formData.pasteimg_path.filter(item => item.status === 0).map(item => item.pasteImg);
                if(pasteImgArray.length > 0){
                    // 将pasteImgArray中的项连接成逗号分隔的字符串
                    state.formData.pasteImg = pasteImgArray.join(',');
                }
            }
             // 合并两个数组
            // @ts-ignore
            const combinedLabels = [...classify_label, ...group_label];

            // 去重
            const uniqueLabels = Array.from(new Set(combinedLabels));

            // 转换为逗号分隔的字符串
            formData.labels = uniqueLabels.join(',');
            proxy.$http.post('/cake_api/operation_check', {
                save_id,
                is_voluntarily,
                is_choiceness,
                voluntarily_time: voluntarily_time + ' ' + hour,
                soldout_type,
                soldout_reson,
                check_msg,
                check_type,
                pasteImg: state.formData.pasteImg,
                deleteImg: state.formData.deleteImg,
                kf_compare_url,
                kf_compare_price,
                labels: formData.labels,
                is_gross
            }).then(res => {
                const { code, data, msg } = res
                if (code != 200) {
                    return proxy.$message({ type: 'error', message: msg })
                }
                
                store.commit(UserMutationTypes.MINUS_MENU_WARNING_ITEM, 'unCheckProduct') // 菜单提醒数字减一
                state.productShelfShow = false // 关闭下架类型弹框
                state.onRejectDialogClose() // 清空驳回弹框内容

                // 获取下一条待审核数据并返回顶部
                if(!sessionStorage.getItem('productString')){
                     // 获取下一条待审核数据并返回顶部
                    if (typeof data != 'object') {
                        proxy.$message({ type: 'success', message: '审核成功，即将进入下一条' })

                        setTimeout(() => {
                            router.replace(route.fullPath.replace(`?id=${save_id}&`, `?id=${data}&`))
                            document.documentElement.scrollTop = 0
                        }, 2000)
                    }else {
                        proxy.$message({ type: 'warning', message: '辛苦啦-休息会吧，没有待审核记录了~' })
                        router.go(-1)
                    } 
                }else {
                    let productString = sessionStorage.getItem('productString')
                    //@ts-ignore
                    state.productArr = productString.split(',').map(Number);
                    // 找到与 save_id 相同的 ID 在数组中的索引
                    //@ts-ignore
                    const indexOfSaveId = state.productArr.indexOf(Number(save_id));
                    if (indexOfSaveId !== -1) {
                        // 从数组中删除与 save_id 相同的 ID
                        state.productArr.splice(indexOfSaveId, 1);
                        // 更新存储在 sessionStorage 中的字符串
                        sessionStorage.setItem('productString', state.productArr.join(','));
                    }
                    proxy.$message({ type: 'success', message: '审核成功，即将进入下一条' });
                    setTimeout(() => {
                        if (state.productArr.length > 0) {
                            router.replace(route.fullPath.replace(`?id=${save_id}&`, `?id=${state.productArr[0]}&`));
                            document.documentElement.scrollTop = 0;
                        } else {
                            proxy.$message({ type: 'warning', message: '辛苦啦-休息会吧，没有待审核记录了~' });
                            router.go(-1);
                        }
                    }, 2000);
                }
            })  
        },
        // 驳回弹框关闭前清空数据
        onRejectDialogClose: () => {
            state.check_msg = ''
            state.rejectDialog = false
        },
        // 当选中品牌发生变化
        onBrandChange: (val:number) => {
            const { brandList } = state
            state.shop_discount = brandList.find(item => item.id == val).shop_discount
            // @ts-ignore
            state.formData.brand_cat_id = brandList.find(item => item.id === val).cat_id // 重新定义当前品牌品类
            state.formData.cat_id       = ''    // 将当前商品品类值设置为默认值
        },
        //通过品牌获取是否快递蛋糕
        getExpress: (brand_id) => {
            proxy.$http.get('/cake_api/get_brand_distribution_rule',{brand_id}).then((res:any) => {
                const { code, data, msg } = res
                if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
                state.is_kd = data.is_kd
                state.is_tc = data.is_tc
                state.brandLimit = data.up_limit
            })
        },
        containsStr(str) {
            return str.indexOf("人食") !== -1;
        },
        onSpecDialogClose:() => {
            state.specOptions = {
                id:'', name: '',spec_img:'',description:'',  tastes:'', market_price: '',   
                price:'', stock: '',  clearing_price:'',  gift:'',    sku: '',    is_import:  0,    
                product_code: '',    unit:  '',  shop_discount:  '',  deleted: 0, is_new:  '',     
                is_activity:  0, isUnlimited: false, code_spec_name: '', code_name:  '',
                code_firm_name: '',code_brand_name: '',code_img: '',product_code_add:false,
            };
            state.specDialog = false;
            state.currSpecIndex = -1;
        },
        // 添加规格
        submitSpec: async () => {
            // 检查规格名称、规格描述是否包含敏感词
            const specNameResult = await isSensitive(state.specOptions.name)
            if (specNameResult !== true) return proxy.$message({ type: 'error', message: `规格名称中包含敏感词：${specNameResult}` })
            const specDescResult = await isSensitive(state.specOptions.description)
            if (specDescResult !== true) return proxy.$message({ type: 'error', message: `规格描述中包含敏感词：${specDescResult}` })
            //规格折扣不能大于品牌折扣
            if(state.specOptions.shop_discount>state.shop_discount){
                return proxy.$message({ type: 'error', message: '规格折扣不能大于品牌折扣('+state.shop_discount+')' })
            }
            if(state.second_brand_name_type){
                return proxy.$message({ type: 'error', message: '69码品牌与当前商品品牌不一致，请修改' })
            }
            proxy.$refs['addSpecFrom'].validate((valid:boolean) => {
                if (valid) {
                    const { currSpecIndex } = state
                    //必填：蛋糕类除面包糕点 其余不必填
                    if(state.formData.cat_id == 1 && state.formData.cat_id3 != 44 && state.specOptions.description==''){
                        return proxy.$message({ type: 'error', message: '请先选择规格描述' })
                    }
                    if(state.formData.cat_id == 1 &&  !state.containsStr(state.specOptions.description)){
                        state.specOptions.description = state.specOptions.description+'人食'
                    }
                    if(state.specOptions.isUnlimited){
                        state.specOptions.stock = '-9999999'
                    }
                    // 检验是否有相同规格名称
                    const { cat_id,cat_id2 } = state.formData
                    const resetSpecOptions = () => {
                        state.specOptions = {
                        id:'',
                        name:'',
                        description:'',
                        deleted:0,
                        market_price:'',
                        sku:'',
                        price:'',
                        stock:'',
                        clearing_price:'',
                        gift:'',
                        tastes:'',
                        shop_discount:'',
                        spec_img:'',product_code_add:false,
                        };
                        state.specDialog = false;
                    };
                    if(cat_id == 5 && cat_id2 != 76){
                        const { name,clearing_price,product_code,is_import } = state.specOptions
                        proxy.$http.post('/admin/products/commodity_bidding', {
                            product_name:state.formData.title,
                            spec_name:name,
                            clearing_price,
                            product_code:is_import == 0 ? product_code : '',
                            spec_id:state.t === 'view' ? '' : state.specOptions.id,
                            product_id:state.formData.id ||'',
                        }).then((res:any) => {
                            if(state.t === 'edit'){
                                state.specOptions.sc_num  = res.data.sc_num 
                            }
                            if(res.code == 200){
                                if(res.data.type == 1){
                                    state.formData.is_yy_check = res.data.shenpi == 2 ? 1 : 0
                                    if (currSpecIndex === -1) {   // 新增
                                        let sameIndex = state.formData.specs_list.findIndex((item:any) => item.name == state.specOptions.name)
                                        if (sameIndex > -1) {
                                            return proxy.$message({ type: 'error', message: '当前规格名称已存在' })
                                        } else {
                                            //@ts-ignore
                                            state.formData.specs_list.push(state.specOptions);
                                            state.currSpecIndex = -1;
                                        }
                                    } else {    // 编辑
                                        //@ts-ignore
                                        state.formData.specs_list[currSpecIndex] = state.specOptions
                                        state.currSpecIndex = -1;
                                    }
                                    resetSpecOptions()
                                }else if(res.data.type == 2){
                                    proxy.$message({type:'error',message:'该商品名称及规格名称已存在，请修改',duration:8000})
                                    state.specDialog = true
                                }else{
                                    proxy.$message({type:'error',message:'平台存在更优相同商品',duration:8000})
                                    state.specDialog = true
                                }
                            }else{
                                proxy.$message({type:'error',message:res.msg})
                                state.specDialog = true
                            }
                        })
                    }else{
                        if (currSpecIndex === -1) {   // 新增
                            let sameIndex = state.formData.specs_list.findIndex((item:any) => item.name == state.specOptions.name)
                            if (sameIndex > -1) {
                                return proxy.$message({ type: 'error', message: '当前规格名称已存在' })
                            } else {
                                //@ts-ignore
                                state.formData.specs_list.push(state.specOptions);
                            }
                            } else {    // 编辑
                                //@ts-ignore
                                state.formData.specs_list[currSpecIndex] = state.specOptions
                                state.currSpecIndex = -1
                            }
                            resetSpecOptions()
                    }
                }
            })
        },
        handleStockInput(value) {
            state.specOptions.stock = value.replace(/[^0-9]/g, '');
            if (value && state.specOptions.isUnlimited) {
                state.specOptions.isUnlimited = false;
            }
        },
        // 打开规格表单
        showAddSpec:()=>{
            // 请求二级品牌、三级分类列表
            state.getProductCats()
            if (state.formData.brand_cat_id === BrandCat['蛋糕'] || state.formData.brand_cat_id === BrandCat['零食']) {
                const { brand_id, cat_id } = state.formData
                getSecondBrandList(brand_id, cat_id)
            }
            state.shop_discount = state.brandList.find(item => item.id == state.formData.brand_id).shop_discount
            const validDiscounts = [state.cat_id3_discount,state.secondary_brand_discount,state.shop_discount].filter(v => v > 0);
            state.minDiscount = validDiscounts.length ? Math.min(...validDiscounts) : 0;
            // 增加商品分类、二级分类、商品名称判断
            if(!state.formData.cat_id)  return proxy.$message({ type: 'error', message: '请先选择品类' })
            if(!state.formData.cat_id3)  return proxy.$message({ type: 'error', message: '请先选择商品分类' })
            if(!state.formData.title)  return proxy.$message({ type: 'error', message: '请先输入商品名称' })
            state.specDialog = true
            state.specOptions.id = ''
            state.specOptions.name = ''
            state.specOptions.description = ''
            state.specOptions.deleted = 0
            state.specOptions.market_price = ''
            state.specOptions.price = ''
            state.specOptions.sku = ''
            state.specOptions.clearing_price = ''
            state.specOptions.stock = ''
            state.specOptions.gift = ''
            state.specOptions.tastes = ''
            state.specOptions.shop_discount = ''
            state.specOptions.isUnlimited = true
            state.specOptions.code_spec_name = ''
            state.specOptions.code_name =  ''
            state.specOptions.code_firm_name = ''
            state.specOptions.code_brand_name = ''
            state.specOptions.code_img = ''
            state.specOptions.product_code = ''
            state.specOptions.product_code_add = true
        },
        // 删除一条规格
        delSpec:(index:number)=>{
            state.formData.specs_list.splice(index,1)
        },
        // 收费附件
        showAddCharge:()=>{
            state.chargeDialog = true;
            state.chargeOptions.id = ''
            state.chargeOptions.name = ''
            state.chargeOptions.unity = '份'
            state.chargeOptions.price = ''
            state.chargeOptions.type = ''
            state.chargeOptions.limit = ''
            state.chargeOptions.sku = ''
            state.chargeOptions.status = 1
            state.chargeOptions.is_candle = ''
        },
        // 删除一条收费附件
        delCharge:(index:number)=>{
            state.formData.charges_list.splice(index,1);
        },
        // 修改收费附件上下架状态
        changeStatus: (id, status) => {
            proxy.$confirm(`确定要【${status == 0 ? '上架' : '下架'}】该附件吗？`, '提示', {
                type: 'warning'
            }).then(() => {
                updateAttachmentStatusApi(id, status ^ 1).then((res:any) => {
                    const { code, data, msg } = res
                    if (code != 200) return proxy.$message({ type: 'error', message: msg })
                    proxy.$message({ type: 'success', message: '修改成功' })
                    state.getProductInfo()
                })
            }).catch(() => {
                console.log('')
            })
        },
        updateChargesList:(charges_list) => {
            // 遍历 charges_list 查找相同的项
            for (let i = 0; i < charges_list.length; i++) {
                let item = charges_list[i];

                // 找到 name 为 '数字蜡烛' 并且 unity 为 '个' 并且 type 为 4 的数据
                if (item.name === '数字蜡烛' && item.unity === '个' && item.type === 4) {
                    // 如果当前项没有 ID，说明它是新添加的数据
                    if (!item.id) {
                        // 遍历 charges_list 查找已有 ID 的同名项
                        for (let j = 0; j < charges_list.length; j++) {
                            let existingItem = charges_list[j];

                            // 如果找到相同的项，并且该项有 ID
                            if (existingItem.name === '数字蜡烛' && existingItem.unity === '个' && existingItem.type === 4) {
                                // 用新的数据覆盖旧数据，但保留旧数据的 ID
                                charges_list[j] = {
                                    ...existingItem, // 保留旧数据的所有字段
                                    ...item,         // 覆盖新数据中的字段
                                    id: existingItem.id // 保留旧数据的 ID
                                };

                                // 从 charges_list 中移除新的数据，因为已经用它覆盖了旧的数据
                                charges_list.splice(i, 1);
                                return charges_list; // 处理完后直接返回
                            }
                        }
                    }
                }
            }
            return charges_list; // 如果没有找到匹配项，则原样返回
        },
        // 收费附件提交
        submitCharge:()=>{
            proxy.$refs['addChargeFrom'].validate((valid:boolean) => {
                if (valid) {
                    const { currChargeIndex } = state
                    
                    if (currChargeIndex === -1) {   // 新增
                        //@ts-ignore
                        state.formData.charges_list.push(state.chargeOptions)
                        // 计算 is_candle 为 1 的元素数量
                        const candleCount = state.formData.charges_list.filter(item => item.name == '数字蜡烛' && item.unity == '个' && item.type ==4).length;

                        // 如果有两个或更多 is_candle 为 1 的项目，给出提示
                        if (candleCount > 1) {
                            //此商品已经添加过数字蜡烛，您本次操作将会覆盖之前的数字蜡烛数据
                            proxy.$confirm('此商品已添加过数字蜡烛，是否进行替换？', '提示', {
                                type: 'warning',
                            }).then(() => {
                            state.updateChargesList(state.formData.charges_list)

                            }).catch(() => {
                                console.log('取消')
                            })
                            // return proxy.$message({ type: 'warning', message: '此商品已设置过数字蜡烛，请勿重复操作' });
                        } 
                            
                    } else {    // 编辑
                        //@ts-ignore
                        state.formData.charges_list[currChargeIndex] = state.chargeOptions
                        state.currChargeIndex = -1
                    }
                    state.chargeOptions = {
                        id:'',
                        name:'',
                        unity:'',
                        price:'',
                        type: '',
                        limit:'',
                        status: 1,
                        is_candle: '',     //收费附件类型   
                    }
                    state.chargeDialog = false;
                }
            })
        },
        /**
         * 删除图片
         * t：1-商品图，2-详情图，3-商品视频封面图，4-商品视频图
        */
        onImgRemove: (index:number, t:number) => {
            proxy.$confirm('确定要删除该图片？', '提示', {
                type: 'warning',
            }).then(() => {
                if (t === 1) {
                    const { formData, imgPreviewList } = state
                    const { product_images_list, image_id } = formData
                    // @ts-ignore
                    const currImgId = product_images_list[index].id

                    if (currImgId == image_id) { // 如果当前要删除的图片ID与商品列表图ID一致，将商品列表图字段清空
                        state.formData.image_id = ''
                    }

                    product_images_list.splice(index, 1)
                    imgPreviewList.splice(index, 1)

                    state.formData.product_images_list = product_images_list
                    state.imgPreviewList = imgPreviewList
                } else if (t === 3) {
                    state.formData.poster = ''
                } else if (t === 4) {
                    state.formData.video = ''
                } else {
                    const { formData, contentImgPreviewList } = state
                    const { content_images_list } = formData

                    content_images_list.splice(index, 1)
                    contentImgPreviewList.splice(index, 1)

                    state.formData.content_images_list = content_images_list
                    // 清除存储的数据
                    localStorage.removeItem('uploadedImage');
                    state.contentImgPreviewList = contentImgPreviewList
                    state.isAddDetailImg = 0
                }
            }).catch(() => {
                console.log('取消删除')
            })
        },
        //获取品牌列表
        getBrandList:()=>{
            store.dispatch(AppActionTypes.ACTION_SET_GLOBALLOADING, true)
            proxy.$http.get('/cake_api/get_brand_list').then((res:any) => {
                store.dispatch(AppActionTypes.ACTION_SET_GLOBALLOADING, false)
                const {code, data, msg} = res
                if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }

                state.brandList = res.data
            })
        },
        // 商品视频上传前校验
        onMp4BeforeUpload: (file) => {
            return beforeUpload(file, {minSize: 150, size: 1024*5})
        },
        // 视频封面、商品图和规格图上传前校验
        onBeforeUpload: (file) => {
            return beforeUpload(file, {minSize: 50, size: 1024, width:800, height:800})
        },
        // 商品详情图上传前校验
        onContentBeforeUpload: (file) => {
            return beforeUpload(file, {size:1024*5, width:[750, 790], maxHeight: 10000})
        },
        // 商品图片上传事件
        onImgUpload: (param) => {
            // @ts-ignore
            state.formData.product_images_list.push({uid: param.file.uid})
            state.uploadRequest(param, 1)
        },
        // 配料表图片上传事件
        onIngredientUpload: async (param) => {
            const { code, data, msg } = await upload(param.file, {folderName: 'product'}) as any
            if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
            const { o_path:url } = data.img_info
            
            const checkRes = await checkIngredientsImage(url) as any
            if (!checkRes.data) {
                return proxy.$message({ type: 'error', message: '配料表图不合规，请重新上传' })
            }

            state.formData.ingredient_img.push(url)
            state.ingredientPreviewList.push(url)
        },
        onIngredientRemove: (index) => {
            state.formData.ingredient_img.splice(index, 1)
            state.ingredientPreviewList.splice(index, 1)
        },
        // 规格图片上传事件
        onImgUploadSpecs: (param) => {
            state.uploadSpecs(param)
        },
        //规格图片删除事件
        removeSpecImage: (id) => {
            if(state.specOptions.is_new){
                state.specOptions.spec_img = '' // 清空规格图数据
            }else {
                proxy.$confirm('确定要删除该图片？', '提示', {
                    type: 'warning'
                }).then(() => {
                    proxy.$http.post('/cake_api/delSpecsImg ', {specs_id:id}).then(res => {
                        if (res.code == 200) {
                            state.specOptions.spec_img = '' // 清空规格图数据
                            proxy.$message({
                                type: 'success',
                                message: '删除成功'
                            })
                            state.getProductInfo()
                        } else {
                            proxy.$message({
                                type: 'error',
                                message: res.msg
                            })
                        }
                    })
                }).catch(() => {
                    console.log('取消删除')
                })
            }
        },
        // 商品详情图片上传事件
        onContentImgUpload: (param) => {
            // @ts-ignore
            state.formData.content_images_list.push({uid: param.file.uid})
            state.uploadRequest(param, 2)
            state.isAddDetailImg = 1
        },
        // 视频封面图上传
        uploadPosterRequest: async (param) => {
            const { code, data, msg } = await fileUpload(param.file, {folderName: 'product'}) as any
            if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
            const { uid, file_name:name, url } = data
            state.formData.poster = url
        },
        // 视频上传
        uploadMp4Request: async (param) => {
            const { code, data, msg } = await fileUpload(param.file, {folderName: 'product'}) as any
            if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
            const { uid, file_name:name, url } = data
            state.formData.video = url
            state.video_name = data.file_name
        },
        // 自定义图片上传方法
        uploadRequest: async (param, type) => {
            const res:any = await upload(param.file, {folderName: 'product'})
            const { code, data, msg } = res
            if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
            const { uid, img_info } = data
            const { id, o_path:url, file_name } = img_info
            let item = { id, url, file_name }
            if (type === 1) {
                let fitItemIndex = state.formData.product_images_list.findIndex((item:ImgItemInt) => item.uid == uid)
                // @ts-ignore
                state.formData.product_images_list[fitItemIndex] = { uid, ...item }
                state.imgPreviewList = []

                state.formData.product_images_list.map((item:ImgItemInt) => {
                    if (item.id && item.url) {
                        // @ts-ignore
                        state.imgPreviewList.push(item.url)
                    }
                })
            } else {
                let fitItemIndex = state.formData.content_images_list.findIndex((item:ImgItemInt) => item.uid == uid)
                // @ts-ignore
                state.formData.content_images_list[fitItemIndex] = { uid, ...item }
                state.contentImgPreviewList = []
                state.formData.content_images_list.map((item:ImgItemInt) => {
                    if (item.id && item.url) {
                        // @ts-ignore
                        state.contentImgPreviewList.push(item.url)
                    }
                })
            }
        },
        uploadSpecs: async (param) => {
            const res:any = await upload(param.file, {folderName: 'specs'})
            const { code, data, msg } = res
            if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
            const { uid, img_info } = data
            const { id, o_path:url, file_name } = img_info
            let item = { id, url, file_name }
            state.specOptions.spec_img = url
            state.specOptions.is_new = '1'
        },
        // 获取规格详细信息
        editSpec: (row, index) => {
            if(!state.formData.brand_id){
                return proxy.$message({ type: 'error', message: '请先选择品牌' })
            }
            if (!state.formData.cat_id3 ) {
                return proxy.$message({ type: 'error', message: '请先选择商品分类' })
            }
            if (state.formData.cat_id  === 5 && !state.formData.secondary_id ) {
                return proxy.$message({ type: 'error', message: '请先选择二级品牌' })
            }
            // 请求品牌、三级分类列表
            state.getProductCats()
            if (state.formData.brand_cat_id === BrandCat['蛋糕'] || state.formData.brand_cat_id === BrandCat['零食']) {
                const { brand_id, cat_id } = state.formData
                getSecondBrandList(brand_id, cat_id)
            }
            state.shop_discount = state.brandList.find(item => item.id == state.formData.brand_id).shop_discount
            const validDiscounts = [state.cat_id3_discount,state.secondary_brand_discount,state.shop_discount].filter(v => v > 0);
            state.minDiscount = validDiscounts.length ? Math.min(...validDiscounts) : 0;

            state.specOptions = {
            ...state.specOptions, 
            ...row,  
            isUnlimited: row.stock == '-9999999',
            stock: row.stock == '-9999999' ? '' : row.stock
            };
            state.specDialog    = true      // 显示规格弹框
            state.currSpecIndex = index     // 设置当前操作规格索引值
            state.specOptions.product_code_add = false 
        },
        // 更新规格上下架状态  运营下架is_admin = 1
        updateSpecStatus: (row) => {
            const { id:specs_id, name, deleted } = row
            proxy.$confirm(`确定要 ${ deleted ? '上架' : '下架'}${name} 吗？`, '提示', {
                type: 'warning'
            }).then(() => {
                //state.source =1 添加传值is_admin = 1
                 // 定义额外的参数对象
                var is_admin = '';
                // 根据 state.source 的值决定是否添加 is_admin 参数
                if (state.source == '1') {
                    //@ts-ignore
                    is_admin = 1 ;
                }
                updateSpecStatusAPi(specs_id,is_admin ).then((res:any) => {
                    const { code, data, msg } = res
                    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
                    proxy.$message({ type: 'success', message: '操作成功' })
                    row.deleted = deleted ^ 1 // 修改视图显示值
                })
            }).catch(() => {
                console.log('取消规格上下架操作')
            })
        },
        // 获取收费附件详细信息
        editCharge: (row, index) => {
            state.chargeOptions   = {...row}  // 规格回显数据
            state.chargeDialog    = true      // 显示规格弹框
            state.currChargeIndex = index     // 设置当前操作规格索引值
             //根据是否为数字蜡烛显示不同的标签
            if(row.name == '数字蜡烛' && row.unity == '个'){
                state.chargeOptions.is_candle = 2
            }else{
                state.chargeOptions.is_candle = 1
            }
        },
        showPromise(){
            window.open(state.formData.merchant_promise_letter || default_merchant_promist_letter)
        },
        handleImportChange(e){
            if(e == 1 || e == 2){
                state.specOptions.product_code = ''
            }
        }
    })
    const shouldHighlight = computed(() => {
        return  (
            state.formData.merchant_compare_num !== '' &&
            state.formData.merchant_compare_num <= 200 &&
            state.formData.merchant_checked_promise === 0
        )
    })
    const mainPreviewList = computed(() => {
        const { product_images_list } = state.formData
        let tmpArr = product_images_list.map(item => {
            // @ts-ignore
            if (item.id && item.url) {
                // @ts-ignore
                return (item.url?.replace('?x-oss-process=style/s_img_160', ''))?.replace('_s.jpg', '.jpg')
            }
        })
        return tmpArr
    })
    const canShowAttachment = computed(() => {
        return !forbiddenUserIds.value.has(state.user_id);
    })
    // 预售时间判断
    const disabledPreSaleDate = (date) => { // 返回开始不可用日期
        //所选时间小于等于当前日期
        return (date.getTime()) <= Date.now() - 1000*60*60*24
    }
    const disabledEndSaleDate = (date) => { // 返回结束不可用日期
        //将时间转换为时间戳
        const start = new Date(state.formData.pre_sale_date).getTime()
        //计算开始到结束的天数
        const preSaleDate = (date.getTime() - start)/1000/60/60/24
        //日期范围大于30天且日期范围不能小于0
        return preSaleDate > 30 || preSaleDate < 0
    }
    // 定时上架日期是否可选
    const disabledVoluntarilyDate = (date) => {
        return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59).getTime() < Date.now()
    }
    // 定时上架时间是否可选
    const voluntarilyTimeDisabled = (time) => {
        return new Date(state.formData.voluntarily_time + ' ' + time).getTime() < Date.now()
    }
    // 滑动到表单错误项
    const moveToErr = () => {
        nextTick(() => {
            let isErr = document.getElementsByClassName('is-error')
            if (isErr.length) {
                isErr[0].scrollIntoView({
                    block: 'center',
                    behavior: 'smooth'
                })
            }
        })
    }
    const secondBrandList = ref([]) // 二级品牌列表
    // 获取二级品牌列表
    const getSecondBrandList = async (brand_id:string) => {
        const { code, data, msg } = await getSecondBrandListNoPageApi(brand_id) as any
        if (code!= 200) { return proxy.$message({ type: 'error', message: msg }) }
        
        data.map((item) => {
            item.disabled = Boolean(item.status!=1)
        })
        secondBrandList.value = data
        const {secondary_id} = state.formData
        // 二级品牌折扣
        let discount = 0
        discount = Number(data.find(item => item.id == secondary_id)?.limit_discount) || 0
        state.secondary_brand_discount = discount
    }
    // 获取物流快递列表
    const getLogisticsList = () => {
        proxy.$http.get('/cake_api/getProductCatList').then(res => {
            const {code, data, msg} = res
            if (code != 200) {
                return proxy.$message({
                    type: 'error',
                    message: msg
                })
            } 
            state.LogisticsList = data.data
        })
    }
    //获取标签列表
    const getTagsGroup = () => {
        const { cat_id } = state.formData
        if (cat_id) {
            proxy.$http.get('/cake_api/getTagsGroup', { cat_id }).then(res => {
                const { code, data, msg } = res
                if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
                state.tagList = data
            })
        }
    }
    // 重新组装 formData 里的 tag_list
    const resetTagList = () => {
        const { tagList, formData } = state
        const { tag_list } = formData
        tagList.map((item:any) => {
            let group_id = item.group_id
            if (!tag_list[`${group_id}`]) {
                // @ts-ignore
                tag_list[`${group_id}`] = []
            }
        })
    }
    // 过滤特殊字符：不允许输入4字节Unicode字符、英文单双引号、分号、反引号、换行符、大于小于等于号、反斜杠
    const filterSpecialChars = (value: string) => {
        return value.replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]|['";`<>=\\\n\r]/g, '')
    }
    // 判断比价链接是否为正确链接
    const checkUrl = (rule:any, val:any, callback:any) => {
        isValidURL(val) ? callback() : callback(new Error('请输入有效链接'))
    }
    // 验证蛋糕品牌-原料必填
    const checkMaterial = (rule:any, val:any, callback:any) => {
        const { cat_id, extra_data } = state.formData
        if (cat_id==`${BrandCat['蛋糕']}` && extra_data.material=='') {
            callback(new Error('请输入原料'))
        } else {
            callback()
        }
    }
    // 验证发票和税点：当发票类型为专票或普票时，税点必填；当税点填写时发票类型必选
    const checkInvoiceType = (rule:any, val:any, callback:any) => {
        const { invoice_type, tax_Point } = state.formData
        if (!invoice_type && tax_Point) {
            callback(new Error('请选择发票类型'))
        } else {
            callback()
        }
    }
    const checkTaxPoint = (rule:any, val:any, callback:any) => {
        const { invoice_type, tax_Point } = state.formData
        if ((InvoiceType[invoice_type]=='专票'|| InvoiceType[invoice_type]=='普票') && !tax_Point) {
            callback(new Error('请输入税点'))
        } else {
            callback()
        }
    }
    // 规格表单，市场价不能小于售价验证
    const checkPrice = (rule:any, val:any, callback:any) => {
        const { market_price, price } = state.specOptions
        if (market_price && price && Number(market_price) < Number(price)) {
            let errorMsg = rule.field === 'price' ? '售价不能大于市场价' : '市场价不能于小售价'
            callback(new Error(errorMsg))
        } else {
            callback()
        }
    }
    // 检验69码
    const checkCode = (rule:any, val:any, callback:any) => {
        const {product_code} = state.specOptions
        if(state.specOptions.product_code_add){
            const existingCodes = state.formData.specs_list.map((item: any) => item.product_code)
            if (existingCodes.includes(val)) {
                proxy.$message({type:'error',message:'本商品不可重复69码'})
                callback(new Error("")); 
            }
        }else{
            const existingCodes = state.formData.specs_list.filter((item: any, index: number) => index !== state.currSpecIndex).map(item => item.product_code);
            if (existingCodes.includes(val)) {
                proxy.$message({type:'error',message:'本商品不可重复69码'})
                callback(new Error(""));
            }
        }
        const brand_name = secondBrandList.value.find(item => item.id == state.formData.secondary_id)?.name
        proxy.$http.post('/cake_api/valid_shipincode', { product_code,brand_id:state.formData.brand_id,second_brand_name:brand_name}).then((res:any) => {
            const { msg, code, data } = res
            if(code != 200){
                proxy.$message({ type: 'error', message: msg })
                callback(new Error(''))
                state.specOptions.code_spec_name = ''
                state.specOptions.code_name  = ''
                state.specOptions.code_firm_name  = ''
                state.specOptions.code_brand_name  = ''
                state.specOptions.code_img = ''
                state.second_brand_name_type = false
            }else{
                callback()
                state.specOptions.code_spec_name = data.code_spec_name
                state.specOptions.code_name  = data.code_name 
                state.specOptions.code_firm_name  = data.code_firm_name 
                state.specOptions.code_brand_name  = data.code_brand_name 
                state.specOptions.code_img = data.code_img
                state.second_brand_name_type = data.second_brand_name_type == 2 ? true : false
                if(state.second_brand_name_type){
                    proxy.$message({type:'error',message:'69码品牌与当前商品品牌不一致，请修改'})
                }
            }
        })
    }
    const checkDiscount = (rule:any, val:any, callback:any) => {
        if (state.source != 1 && state.minDiscount && state.minDiscount < val)  return  callback(new Error(''))
        callback()
    }
    const shelfRule = reactive ({
        soldout_type: [
            { required: true, message: '请选择下架类型', trigger: 'blur' }
        ]
    })
    // 校验规格名称，不得超过15个汉字（英文、英文符号、数字按 0.5 计算）
    const checkNameLength = (rule:any, val:any, callback:any) => {
        if (getStrLength(val) > 15) {
            callback(new Error('规格名称不能超过15个汉字'))
        } else {
            callback()
        }
    }
    const isRequiredDelivery = (cat_id2,is_kd) => {
        //@ts-ignore
        if(cat_id2 == 61 || is_kd == 1){
            return true
        }else {
            return false
        }
    }
    const isDeliveryRequired = computed(() => {
        return isRequiredDelivery(state.formData.cat_id2, state.is_kd)
    })
    const isNumber = (rule:any, val:any,callback:any) =>{
        if(state.formData.is_compare == 1 && (state.source == 2 || state.o == 3 )){
            if (!val || parseFloat(val) <= 0) {
            callback(new Error('必须大于0')); 
            }  else {
                callback()
            }
        }else{
            callback()
        }
    }
    const isCompare = computed(() => {
        if(state.formData.is_compare == 1 && (state.source == 2 || state.o == 3 )){
                return true
            }else {
                return false
            }
    })
    const isLabelNameRequired = computed(() => {
        if(state.source == 1){
                return false
            }else {
                return true
            }
    })
    // 校验保质期，不得超过2000天
    const checkExpiryDays = (rule:any, val:any, callback:any) => {
        if (!val || parseFloat(val) <= 0 || parseFloat(val) > 2000) {
            callback(new Error('保质期不能超过2000天')); 
        }  else {
            callback()
        }
    }
    // 商品表单验证规则
    const productRules = reactive({
        brand_id: [
            { required: true, type: 'number', message: '请选择品牌', trigger: 'change' }
        ],
        spu: [
            { required: true, message: '请输入SPU编号', trigger: 'blur' }
        ],
        cat_id: [
            { required: true, message: '请选择品类', trigger: 'change' }
        ],
        cat_id3: [
            { required: true, message: '请选择商品分类', trigger: 'change' }
        ],
        secondary_id: [
            { required: true, message: '请选择二级品牌', trigger: 'change' }
        ],
        is_pre_sale: [
            { required: true, message: '请选择是否为预售商品', trigger: 'change' }
        ],
        pre_sale_date: [
            { required: true, message: '请选择预售时间', trigger: 'change' }
        ],
        title: [
            { required: true, message: '请输入商品名称', trigger: 'blur' }
        ],
        description: [
            { required: true, message: '请输入商品介绍', trigger: 'blur' }
        ],
        is_compare: [
            { required: true, message: '请选择是否加入比价链接', trigger: 'change' }
        ],
        compare_url: [
            { required: true, message: '请输入比价链接', trigger: 'blur' },
        ],
        compare_msg: [
            { required: true, message: '请输入不加入比价原因', trigger: 'blur' }
        ],
        extra_data: {
            material: [
                { validator: checkMaterial, trigger: 'blur' }
            ],
            storage: [
                { required: true, message: '请输入储存条件', trigger: 'blur' }
            ],
            introduce: [
                { required: true, message: '请输入推荐理由', trigger: 'blur' }
            ],
            expiry_days: [
                { required: true, message: '请输入保质期', trigger: 'blur' },
                { validator: checkExpiryDays, trigger: 'blur' }
            ]
        },
        reserve_type: [
            { required: true, message: '请选择储存方式', trigger: 'change' }
        ],
        is_greeting: [
            { required: true, message: '请选择是否支持祝福语配置', trigger: 'change' }
        ],
        label_name: [
            { required: isLabelNameRequired, message: '请选择至少一种商品标签', trigger: 'change' }
        ],
        special_tag: [
            { required: true, message: '请选择特殊节日标签', trigger: 'change' }
        ],
        is_voluntarily: [
            { required: true, message: '请选择是否需要定时上架', trigger: 'change' }
        ],
        voluntarily_time: [
            { required: Boolean(state.formData.is_voluntarily), message: '请选择定时审核时间', trigger: 'blur' }
        ],
        invoice_type: [
            { validator: checkInvoiceType, trigger: 'change' }
        ],
        tax_Point: [
            { validator: checkTaxPoint, trigger: 'blur' }
        ],
        delivery_addr: [
            { required: isDeliveryRequired, message: '请选择发货地址', trigger: 'change' }
        ],
        wuliu_cats: [
            { required: isDeliveryRequired, message: '请选择快递', trigger: 'change' }
        ],
        classify_label:[
            { required: true, message: '请选择至少一种商品标签', trigger: 'change' }
        ],
        merchant_compare_price:[
            { required: isCompare, message: '请填写比价价格', trigger: 'blur' },
            { validator: isNumber,trigger: 'blur' }
        ],
        merchant_compare_num:[
            { required: isCompare, message: '请填写比价销量', trigger: 'blur' },
            { validator: isNumber,trigger: 'blur' }
        ],
    })
    const isRequired = (cat_id,cat_id3) => {
        //蛋糕类且三级分类不是面包糕点必填
        //@ts-ignore
        if(cat_id ==1 && cat_id3 !=44){
            return true
        }else {
            return false
        }
    }
    const isDescriptionRequired = computed(() => {
        return isRequired(state.formData.cat_id, state.formData.cat_id3)
    })
    // 规格编辑表单验证规则
    const specRules = reactive({
        name: [
            { required: true, message: '请填写规格名称', trigger: 'blur' },
            { validator: checkNameLength, trigger: 'blur' }
        ],
        gift: [
            { required: true, message: '请填写配套餐具', trigger: 'blur' },
            { validator: checkNameLength, trigger: 'blur' }
        ],
        market_price: [
            { required: true, message: '请填写市场价', trigger: 'blur' },
            { validator: checkPrice, trigger: 'blur' }
        ],
        clearing_price: [
            { required: true, message: '请填写结算价', trigger: 'blur' },
            { required: true, message: '请填写结算价', trigger: 'blur' }
        ],
        shop_discount: [
            { required: true, message: '请填写折扣', trigger: 'blur' },
            { validator: checkDiscount, trigger: 'change' }
        ],
        price: [
            { required: true, message: '请填写售价', trigger: 'blur' },
            { validator: checkPrice, trigger: 'blur' }
        ],
        product_code: [
            { required: true, message: '请填写69码', trigger: 'blur' },
            { validator: checkCode, trigger: 'blur' }
        ],
        description: [
            { required: isDescriptionRequired, message: '请选择规格描述', trigger: 'change' }
        ],
        
    })
    // 收费附件表单验证规则
    const chargeRules = reactive({
        is_candle: [
            { required: true, message: '请选择类型', trigger: 'change' }
        ],
        name: [
            { required: true, message: '请填写附件名称', trigger: 'blur' }
        ],
        price: [
            { required: true, message: '请填写单价', trigger: 'blur' }
        ],
        limit: [
            { required: true, message: '请填写限制数量', trigger: 'blur' }
        ],
        status: [
            { required: true, message: '请选择状态', trigger: 'change' }
        ],
        type: [
            { required: true, message: '请选择附件图标', trigger: 'change' }
        ],
    })
    const hourList = ['00:00:00', '01:00:00', '02:00:00', '03:00:00', '04:00:00', '05:00:00', '06:00:00', '07:00:00', '08:00:00', '09:00:00', '10:00:00', '11:00:00', '12:00:00', '13:00:00', '14:00:00', '15:00:00', '16:00:00', '17:00:00', '18:00:00', '19:00:00', '20:00:00', '21:00:00', '22:00:00', '23:00:00', '24:00:00']
    const handleCandleChange = (val) => {
        if(val == 2){
            state.chargeOptions.type=4
            state.chargeOptions.name = '数字蜡烛'
            state.chargeOptions.unity = '个'
        }else{
            state.chargeOptions.unity = '份'
            state.chargeOptions.type=''
            state.chargeOptions.name = ''
        }
    }
    // 当前选中标签变更
    watch(() => state.formData.classify_label, (newVal, oldVal) => {
        if (newVal.length < oldVal.length) {
            let missVal = oldVal.filter(item => !newVal.includes(item))
            state.formData.group_label = state.formData.group_label.filter(item => item !== missVal[0])
        }
    })
    watch(() => state.formData.group_label, (newVal, oldVal) => {
        if (newVal.length < oldVal.length) {
            let missVal = oldVal.filter(item => !newVal.includes(item))
            state.formData.classify_label = state.formData.classify_label.filter(item => item !== missVal[0])
        }
    })
    // 当前选中品类发生变化，重新获取当前品类所属的标签列表
    watch(() => state.formData.cat_id, (newVal, oldVal) => {
        getTagsGroup()
        resetTagList()
        state.getProductCats()
        if (state.formData.brand_cat_id === BrandCat['蛋糕'] || state.formData.brand_cat_id === BrandCat['零食']) {
            const { brand_id, cat_id } = state.formData
            getSecondBrandList(brand_id, cat_id)
        }
    })
    // 当前品牌发生变化,重新获取当前品牌开通的城市，同时清空二级品牌数据
    watch(() => state.formData.brand_id, (newVal, oldVal) => {
        if (oldVal) {
            state.formData.secondary_id = null
            state.formData.second_brand_name = ''
        }
    })
    // 监听规格结算价和售价变化，动态计算结算折扣
    watch(() => [state.specOptions.clearing_price, state.specOptions.price], (newVal, oldVal) => {
        const clearing_price = newVal[0]
        const price = newVal[1]
        if (clearing_price && price) {
            // @ts-ignore
            state.specOptions.shop_discount = (Math.round(clearing_price / price * 1000) / 10).toFixed(2)
        } else {
            state.specOptions.shop_discount = ''
        }
    })
        // 监听上架日期变化，每当变化时清空时间选项，以确保选择今天时，当前时间之前的时间段不可用
    watch(() => state.formData.voluntarily_time, (newVal, oldVal) => {
        if (newVal) {
            state.hour = ''
        }
    })
    //监听品牌变化，用于编辑显示
    watch(() => [state.formData.brand_id,state.brandList], (newVal, oldVal) => {
        if(newVal[0] && newVal[1].length > 0 ){
            state.getExpress(newVal[0])
        }
    })
    // 监听路由变化，重新获取商品数据（自动获取下一条审核记录）
    watch(() => route.query.id, (newVal, oldVal) => {
        if (newVal) {
            state.formData.save_id = newVal
            state.getProductInfo()
        }
    })

    //监听商品标签的选中状态
    watch(() => state.formData.label_name, (newVal, oldVal) => {
        if (!state.pageLoaded && t !== undefined) return
        const specialLabels = ['京东', '顺丰'];
        //刚刚选择添加过的
        let addedLabel = newVal.filter(x => !oldVal.includes(x)).find(x => specialLabels.includes(x));
        // 提取检测新增特殊标签的逻辑为一个函数
        const containsSpecialLabel = (labels) => labels.some(label => specialLabels.includes(label));
        //如果有特殊标签则显示
        containsSpecialLabel(state.formData.label_name)? state.showNotice = true:state.showNotice = false
        // 用于处理显示警告和用户响应的函数
        const handleSpecialLabel = () => {
            proxy.$confirm('注意：发货订单 仅限勾选的快递，请谨慎 ！', '提示', {
                type: 'error',
            }).then(() => {
                // 用户点击确认后的操作
            }).catch(() => {
                // 用户点击取消后的操作，只从formData.label_name中移除新增的特殊标签
                state.formData.label_name = state.formData.label_name.filter(label => label !== addedLabel);
            });
        };
         // 初始进入页面时，oldValue 是 undefined，可以用于判断是否是刚进入页面
        if (oldVal.length==0) {
            //处理新增、或者没有商品标签的情况
            if(containsSpecialLabel(newVal) && (!state.formData.brand_id || state.formData.label_name.length == 1)){
                // 新增了特殊标签
                handleSpecialLabel()
            }
            return;
        }
        // 判断新增的标签是否包含特殊标签
        //@ts-ignore
        let addedLabels = newVal.filter(x => !oldVal.includes(x));
        if (containsSpecialLabel(addedLabels)) {
            // 新增了特殊标签
            state.showNotice = true;
            handleSpecialLabel()
        }       
    },{ deep: true });
    watch(() => state.specOptions.stock, (newVal, oldVal) => { 
        if (newVal && newVal !== '-9999999') {
            state.specOptions.isUnlimited = false;
            state.specOptions.stock = newVal;
        } else {
            state.specOptions.stock = '';
        }
    }) 
    watch(() => state.cat_id3_discount, () => {
        state.shop_discount = state.brandList.find(item => item.id == state.formData.brand_id).shop_discount
        const validDiscounts = [state.cat_id3_discount,state.secondary_brand_discount,state.shop_discount].filter(v => v > 0);
        state.minDiscount = validDiscounts.length ? Math.min(...validDiscounts) : 0;
    })
    watch(() => state.secondary_brand_discount, () => {
        state.shop_discount = state.brandList.find(item => item.id == state.formData.brand_id).shop_discount
        const validDiscounts = [state.cat_id3_discount,state.secondary_brand_discount,state.shop_discount].filter(v => v > 0);
        state.minDiscount = validDiscounts.length ? Math.min(...validDiscounts) : 0;
    })
    onMounted(() => {
        getLogisticsList()
        state.getAllCityList()
        
        state.getProductCats()
        state.loadAndAddImage()
    })
    onActivated(() => {

    })
    onBeforeRouteLeave(() => {
         // 清除存储的数据
        localStorage.removeItem('uploadedImage');
    })
    state.getBrandList()
    // @ts-ignore
    state.o != 2 && state.getProductInfo()
    // 比价图片上传事件
    const uploadPasteImg = async (param,isMerchant) => {
        const res:any = await upload(param, {folderName:isMerchant == 0 ? 'pasteImg': 'merchantCompareImg'})
        const { code, data, msg } = res
        if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
        const { img_info } = data
        const { id, o_path:url, file_name } = img_info
        let item = { id, url, file_name }
        if(isMerchant == 0){
            //每次上传的时候，添加状态0表示新上传
            //@ts-ignore
            state.formData.pasteimg_path.push({status:0,pasteImg:item.url})
            //每次上传的时候，初始化预览列表，使其和pasteimg_path保持同步
            state.pasteImgPreviewList = []
            state.formData.pasteimg_path.map((item:any) => {
                //@ts-ignore
                state.pasteImgPreviewList.push(item.pasteImg)
            })
        }else if(isMerchant == 1){
            state.formData.merchant_compare_image.push({pasteImg:item.url})
            state.MerchantCompareImgPreviewList = []
            state.formData.merchant_compare_image.map((item:any) => {
                //@ts-ignore
                state.MerchantCompareImgPreviewList.push(item.pasteImg)
            })
        }
    }
    /**
     * 删除图片
    */
    const onRemoveImg = (index:number,isMerchant) => {
        proxy.$confirm('确定要删除该图片？', '提示', {
            type: 'warning',
        }).then(() => {
                debugger
                const { formData, pasteImgPreviewList,MerchantCompareImgPreviewList } = state
                const { pasteimg_path,merchant_compare_image } = formData
                if(isMerchant == 0){
                    //将每次删除的index放到deleteArray中
                    state.deleteArray.push(pasteimg_path[index])
                    //找出旧图片数据中要被删除的图片链接放到 deleteImg 中
                    //@ts-ignore
                    state.oldDeleteArray = state.deleteArray.filter(item => item.status === 1).map(item => item.pasteImg)
                    if(state.oldDeleteArray.length >0){
                        state.formData.deleteImg = state.oldDeleteArray.join(',')
                    };
                    pasteimg_path.splice(index, 1)
                    pasteImgPreviewList.splice(index, 1)

                    state.formData.pasteimg_path = pasteimg_path
                    state.pasteImgPreviewList = pasteImgPreviewList
                }else if(isMerchant == 1){
                    state.merchantDeleteArray.push(merchant_compare_image[index])
                    //@ts-ignore
                    state.oldMerchantDeleteArray = state.merchantDeleteArray.map(item => item.pasteImg)
                    if(state.oldMerchantDeleteArray.length >0){
                        state.formData.deleteImg = state.oldMerchantDeleteArray.join(',')
                    };
                    merchant_compare_image.splice(index, 1)
                    MerchantCompareImgPreviewList.splice(index, 1)
                    state.formData.merchant_compare_image = merchant_compare_image
                    state.MerchantCompareImgPreviewList = MerchantCompareImgPreviewList
                }       
        }).catch(() => {
            console.log('取消删除')
        })
    }
    // 比价图上传前校验
    const onPasteBeforeUpload = (file) => {
        return beforeUpload(file, {size:5000})
    }
    const onPaste = (event,isMerchant) => {
        const items = (event.clipboardData || window.clipboardData).items
        let file = null
        const imageFiles = [];

        if (!items || items.length === 0) {
            return proxy.$message({ type: 'error', message: '不支持' })
        }

        for (let i=0; i<items.length; i++) {
            if (items[i].type.indexOf('image') !== -1) {
                file = items[i].getAsFile()
                // 为 file 对象添加 uid 属性，赋值为当前时间戳
                if(file){
                    //@ts-ignore
                    file.uid = Date.now();
                    imageFiles.push(file);
                }
                // break
            }
        }
        
        // 如果没有找到图片文件，输出一条信息并返回
        if (imageFiles.length === 0) {
            return  proxy.$message({ type: 'error', message: '粘贴内容没有图片' });
        }else {
            // 处理每张图片
            imageFiles.forEach((file) => {
                onPasteBeforeUpload(file).then((result) => {
                    if (result === true) {
                        uploadPasteImg(file,isMerchant);
                    }
                });
            });
        }
    }
    const handleUnlimitedChange = (checked) => {
        if (checked) {
            state.specOptions.stock = '-9999999';
        }
    }
    const brandProps = {
        label: 'name',
        value: 'id',
    }
    return { ...toRefs(state), shouldHighlight, onPaste, brandProps,ChargeType,onPasteBeforeUpload, uploadPasteImg, groupIdArr, userType, offTypes,filterTypes, onRemoveImg, clearBr, productRules, specRules, chargeRules, disabledPreSaleDate, disabledEndSaleDate, disabledVoluntarilyDate, voluntarilyTimeDisabled, BrandCat, CheckStatus, ProductO, InvoiceType, router, hourList, mainPreviewList , isRequired,getLogisticsList,isRequiredDelivery,secondBrandList,activeName,canShowAttachment,handleCandleChange,handleUnlimitedChange,is_snacks,filterSpecialChars }
}
})
